import React from 'react';
import { PageHeader, Space, Divider, Tabs } from 'antd';

import { MyBreadcrumb } from 'utils';

import AccessControlManagement from 'utils/AccessControlManagement';

const { TabPane } = Tabs;

export default function AccessControl(props) {
  return (
    <div>
      <MyBreadcrumb
        items={[
          {
            label: 'Access control',
            path: '/access-control',
          },
          { label: 'Index', path: '' },
        ]}
      />
      <PageHeader
        ghost={false}
        onBack={() => window.history.back()}
        title="Access Control (Group permission)"
        subTitle=""
      >
        <h2>Note: Super Admin have all the accesses</h2>
        <h3>You can allow following roles to manage items</h3>
        <Divider />
        <Space
          size="small"
          style={{ width: '100%' }}
          direction="vertical"
        ></Space>

        <Tabs defaultActiveKey="10">
          <TabPane tab="10 - Super Admin" key={10}>
            <AccessControlManagement role={10} />
          </TabPane>
          <TabPane tab="30 - Reseller Non-Admin and Reseller Admin" key={30}>
            <AccessControlManagement role={30} />
          </TabPane>
          <TabPane tab="40 - Customer Company Admin" key={40}>
            <AccessControlManagement role={40} />
          </TabPane>
          <TabPane tab="41 - IT Support" key={41}>
            <AccessControlManagement role={41} />
          </TabPane>
          <TabPane tab="42 - IT Support God" key={42}>
            <AccessControlManagement role={42} />
          </TabPane>
          <TabPane tab="43 - Accounting Team Only" key={43}>
            <AccessControlManagement role={43} />
          </TabPane>
          <TabPane tab="44 - All Locations – Wi-Fi and Companies" key={44}>
            <AccessControlManagement role={44} />
          </TabPane>
          <TabPane
            tab="45 - All Locations – Wi-Fi and Office Assignment"
            key={45}
          >
            <AccessControlManagement role={45} />
          </TabPane>
          <TabPane tab="50 - Customer Branch Admin" key={50}>
            <AccessControlManagement role={50} />
          </TabPane>
          <TabPane tab="51 - Single Location - WiFi and Companies" key={51}>
            <AccessControlManagement role={51} />
          </TabPane>
          <TabPane
            tab="52 - Single Location – Wi-Fi and Office Assignment"
            key={52}
          >
            <AccessControlManagement role={52} />
          </TabPane>
          <TabPane tab="60 - Customer Non Admin" key={60}>
            <AccessControlManagement role={60} />
          </TabPane>
          <TabPane tab="12 - Workspace Manager" key={12}>
            <AccessControlManagement role={12} />
          </TabPane>
        </Tabs>
      </PageHeader>
    </div>
  );
}
